/**
 * 渐变映射（对比 Photoshop 补全第一档缺口 阶段 1）。
 *
 * 语义：按像素亮度在两色渐变上取色替换整个像素——这跟其余调整不同，
 * **新建时画面必然会变**（真实 Photoshop 新建渐变映射图层同样立刻把画面
 * 转成灰阶渐变色，不存在"恒等参数"这个选项，这是它的核心语义，不是没做
 * 完）。默认黑→白两色渐变（等效标准灰阶映射），跟 Photoshop 默认一致。
 * 只做 2 色渐变，不做完整的多档渐变编辑器（同 `LayerStyleDialog.tsx` 的
 * `gradientOverlay` 简化程度一致）。
 */
export interface GradientMapParams {
  /** 亮度 0 对应的颜色。 */
  readonly color1: readonly [number, number, number];
  /** 亮度 255 对应的颜色。 */
  readonly color2: readonly [number, number, number];
}

export const DEFAULT_GRADIENT_MAP_PARAMS: GradientMapParams = {
  color1: [0, 0, 0],
  color2: [255, 255, 255],
};

function luminance(r: number, g: number, b: number): number {
  return 0.299 * r + 0.587 * g + 0.114 * b;
}

export function applyGradientMap(
  r: number,
  g: number,
  b: number,
  params: GradientMapParams,
): [number, number, number] {
  const t = Math.min(255, Math.max(0, luminance(r, g, b))) / 255;
  const [r1, g1, b1] = params.color1;
  const [r2, g2, b2] = params.color2;
  return [
    Math.round(r1 + (r2 - r1) * t),
    Math.round(g1 + (g2 - g1) * t),
    Math.round(b1 + (b2 - b1) * t),
  ];
}
